/**
 * Coalescência de valor, sem `??` e sem ternário `== null`.
 *
 * POR QUE ESTE ARQUIVO EXISTE
 * O repo proíbe `??` no fonte (o Babel não tem o plugin), então o módulo
 * repetia `x != null ? x : y` em 17 lugares. O SonarQube marca esse ternário
 * como condição negada (`javascript:S7735`), e a correção "óbvia" — inverter
 * para `x == null ? y : x` — é justamente a que **quebra o build**: o Terser
 * 4.8.1 otimiza esse formato para `x ?? y` e, quando `y` tem `&&`/`||`, emite
 * `x ?? a && b` SEM parênteses, que é `SyntaxError` pela gramática do JS. Foi o
 * incidente de 19/06 que derrubou produção e originou o gate
 * `validate-bundles.sh`.
 *
 * As funções abaixo usam `if` explícito de propósito: é a forma que o Terser
 * NÃO transforma em coalesce (`vue.config.js` roda com `reduce_vars: false`,
 * então extrair variável também não resolveria — ele re-inline).
 */

/** `valor`, ou `alternativa` quando ele é `null`/`undefined`. */
export function primeiroDefinido(valor, alternativa) {
  if (valor === null || valor === undefined) return alternativa
  return valor
}

/** `Number(valor)`, ou `null` quando ele é `null`/`undefined`. */
export function numeroOuNulo(valor) {
  if (valor === null || valor === undefined) return null
  return Number(valor)
}

/** `String(valor)`, ou `padrao` quando ele é `null`/`undefined`. */
export function textoOuPadrao(valor, padrao) {
  if (valor === null || valor === undefined) return padrao
  return String(valor)
}
